import { BetaFeature } from "@tvg/sh-lib-beta-program/types";

const QA_LABEL_PREFIX = "beta-program-modal-";

export const QA_LABELS = {
  BODY: QA_LABEL_PREFIX + "body",
  ENROLL_PAGE: QA_LABEL_PREFIX + "enroll-page",
  LEARN_MORE_PAGE: QA_LABEL_PREFIX + "learn-more-page",
  FOOTER: QA_LABEL_PREFIX + "footer",
  BASE_MODAL: QA_LABEL_PREFIX + "base",
  CTA: QA_LABEL_PREFIX + "action",
  FEATURES_LIST: QA_LABEL_PREFIX + "features-list",
  ARTICLE: QA_LABEL_PREFIX + "article",
  DISMISS_TOAST: QA_LABEL_PREFIX + "dismiss-toast",
  FEATURE_LIST_ITEM: QA_LABEL_PREFIX + "features-list-item",
  EMPTY_CASE: QA_LABEL_PREFIX + "empty-case",
  STATUS_TAG: QA_LABEL_PREFIX + "status-tag",
  WELCOME_MODAL: QA_LABEL_PREFIX + "welcome-modal",
  CONFIRM_MODAL: QA_LABEL_PREFIX + "confirm-modal"
};

export const featureLabels: Record<BetaFeature, string> = {
  [BetaFeature.PROGRAM_PAGE]: "Program Page",
  [BetaFeature.MY_STABLE]: "My Stable"
};
